<template>
  <div>
    <el-table :data="supported"
              :cell-style="cellStyle"
              border
              stripe>
      <el-table-column width="200px"
                       label="代码">
        <template slot-scope="scope"><span style="white-space: pre-line;">{{scope.row[0].code}}</span></template>
      </el-table-column>
      <el-table-column label="控件">
        <template slot-scope="scope">
          <item-list v-if="useList(scope.row[0])"
                     :item="scope.row[0]"
                     v-model="data[scope.row[0].id]"
                     :id="scope.row[0].id" />
          <item-content v-else
                        :item="scope.row[0]"
                        v-model="data[scope.row[0].id]"
                        :id="scope.row[0].id" />
        </template>
      </el-table-column>
      <el-table-column label="值">
        <template slot-scope="scope">{{toStr(data[scope.row[0].id])}}</template>
      </el-table-column>

      <el-table-column label="代码">
        <template slot-scope="scope"><span style="white-space: pre-line;">{{scope.row[1].code}}</span></template>
      </el-table-column>
      <el-table-column label="控件">
        <template slot-scope="scope">
          <item-list v-if="useList(scope.row[1])"
                     :item="scope.row[1]"
                     v-model="data[scope.row[1].id]"
                     :id="scope.row[1].id" />
          <item-content v-else
                        :item="scope.row[1]"
                        v-model="data[scope.row[1].id]"
                        :id="scope.row[1].id" />
        </template>
      </el-table-column>
      <el-table-column label="值">
        <template slot-scope="scope">{{toStr(data[scope.row[1].id])}}</template>
      </el-table-column>
    </el-table>
  </div>
</template>
<style scoped>
>>> .el-table td {
  padding: 5px 0;
}
</style>
<script>
import ItemContent from './Content';
import ItemList from './List';
import pm from '../../../util/product_management'

const supported = [
  {
    type: ['company'],
    value: 'alse'
  },
  {
    type: ['age'],
    value: 18
  },
  {
    type: ['age'],
    value: 1,
    options: [
      { value: 1, display: '1岁' },
      { value: 2, display: '2岁' },
      { value: 3, display: '3岁' }
    ]
  },
  {
    type: ['date'],
    value: '2019-01-01'
  },
  {
    type: ['year'],
    value: 1
  },
  {
    type: ['int'],
    value: 2019
  },
  {
    type: ['int'],
    value: 2019,
    options: [
      { value: 1, display: 'One' },
      { value: 2, display: 'Two' },
      { value: 3, display: 'Three' }
    ],
  },
  {
    type: ['large_amount'],
    value: 100000
  },
  {
    type: ['large_amount'],
    value: 100000,
    options: [
      { value: 1, display: '1万元' },
      { value: 10, display: '10万元' },
      { value: 100, display: '100万元' },
    ]
  },
  {
    type: ['name'],
    value: '张三'
  },
  {
    type: ['period'],
    value: 1
  },
  {
    type: ['period'],
    value: 1,
    options: [
      { value: 1, display: '1年' },
      { value: 2, display: '2年' },
      { value: 3, display: '3年' },
    ]
  },
  {
    type: ['range_age'],
    value: [18, 30]
  },
  {
    type: ['range_age_large_amount'],
    value: {
      start_age: 18,
      end_age: 30,
      amount: 100000
    }
  },
  {
    type: ['range_int'],
    value: [0, 100]
  },
  {
    type: ['range_year_rate'],
    value: {
      start_year: 0,
      end_year: 5,
      rate: 1.3
    }
  },
  {
    type: ['rate'],
    value: 1.3
  },
  {
    type: ['string'],
    value: '单行，不能换行'
  },
  {
    type: ['string'],
    options: [
      { value: "01", display: "选项1" },
      { value: "02", display: "选项2" },
    ],
    value: '02'
  },
  {
    type: ['text'],
    value: '第一行\n第二行'
  },
  {
    type: ['periods_and_ages'],
    value: {
      years: [10, 20],
      ages: [55, 60]
    }
  },
  {
    type: ['fee_list'],
  },
  {
    type: ['file']
  }
]

export default {
  name: "ProductItemSupportedTypes",
  components: {
    ItemContent,
    ItemList
  },
  data() {
    let supportedWithList = []
    let data = {}
    for (let i in supported) {
      let s = supported[i]
      let s2 = JSON.parse(JSON.stringify(s))
      s.id = 'id-' + i
      s2.id = 'ids-' + i
      s2.list = true

      supportedWithList.push([s, s2])
    }

    for (let ss of supportedWithList) {
      for (let s of ss) {
        let opts = []
        if (s.list) {
          opts.push('[' + s.type[0] + ']')
        } else {
          opts.push(s.type[0])
        }
        for (let o of (s.options || [])) {
          opts.push(o.value + '|' + o.display)
        }

        s.code = opts.join('\n')
        data[s.id] = s.list ? [s.value] : s.value
      }
    }

    return {
      supported: supportedWithList,
      data: data
    }
  },
  methods: {
    useList(item) {
      return pm.useList(item)
    },
    cellStyle({ columnIndex }) {
      if (columnIndex % 3 != 0) {
        return 'text-align: left'
      } else {
        return 'text-align: left; background-color: #C0C4CC; font-weight: bold;width:100px'
      }
    },
    toStr(v) {
      if (v === undefined || v === null) {
        return ''
      }

      let vv = JSON.stringify(v)
      if (vv.length > 100) {
        return vv.substr(0, 70) + ' ... ' + vv.substr(vv.length - 20)
      }

      return vv
    }
  }
}
</script>